import { render, staticRenderFns } from "./genAll.vue?vue&type=template&id=a25787aa&scoped=true&"
import script from "./genAll.vue?vue&type=script&lang=js&"
export * from "./genAll.vue?vue&type=script&lang=js&"
import style0 from "./genAll.vue?vue&type=style&index=0&id=a25787aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25787aa",
  null
  
)

export default component.exports